<template>
    <transition name="slide-fade">
        <div class="modal ff-reg" :class="{ 'open': open }" v-if="open">
            <div class="modal-content mx-auto max-w-md px-5">
                <div class="bg-white w-full rounded-40 p-4">
                    <div class="modal-base" :class="theme">
                        <div class="modal-base-body">
                            <div class="title mt-2">{{ lbl.confirm.title }}</div>
                            <div class="customer-info">{{ lbl.walletAddress }}</div>
                            <div class="wallet-addr">
                                {{ walletAddrMasked }}
                            </div>

                            <ConvertHeader :lbl="lbl" mode="point" :showTitle="false" :blobConfig="blobConfig"
                                :pointRaw="pointRaw" :pointConverted="pointConverted" />
                            <div class="warning-text">
                                {{ lbl.confirm.warning_text }}
                            </div>
                        </div>
                        <div class="modal-base-footer">
                            <div class="wrapper-ok-btn">
                                <button type="button" class="btn btn-ok capitalize" @click="clickOk()">
                                    {{ lbl.base_button.confirm }}
                                </button>
                            </div>
                            <div class="wrapper-cancel-btn py-4">
                                <button type="button" class="btn btn-cancel capitalize text-normal" @click="hide()">
                                    {{ lbl.base_button.cancel }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import { inject } from "vue";
//import Button from '@/components/Button/Button.vue';
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
import ConvertHeader from "../../../Header/ConvertHeader.vue";
export default {
    name: "ConfirmModal",
    components: {
        // Button,
        ConvertHeader,
    },
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    setup: function () {
        const { lbl, localeCode } = inject("LocaleStore")
        // const TheOneService = inject("TheOneService")

        return {
            lbl,
            localeCode,
            // TheOneService
        }
    },
    data: function () {
        return {
            open: false,
            theme: "",
            title: "",
            message: "",
            btnOk: "",
            btnCancel: "",
            tag: "",
            partner: 0,
            blobConfig: {},
            pointConverted: 0,
            pointRaw: 0,
            busModal: null,
            walletAddr: "",
            isCancel: false
        };
    },
    computed: {
        walletAddrMasked: function () {
            if (this.walletAddr.length > 0) {
                return `${this.walletAddr.substring(
                    0,
                    6
                )}...${this.walletAddr.substring(this.walletAddr.length - 4)}`;
            } else {
                return "";
            }
        },
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on("show", this.show);
        this.busModal.on("hide", this.hide);
    },
    methods: {
        onModalHidden: function () {
            this.controller.sendCallbackHidden({ tag: this.tag, cancel: this.isCancel });
        },
        clickOk: function () {
            this.isCancel = false
            this.hide()
            this.controller.sendCallbackOk({ tag: this.tag });
            this.$nextTick(this.onModalHidden)
        },
        show: function (config) {
            this.isCancel = false
            this.title = config.title;
            this.message = config.msg;
            this.btnCancel = config.btnCancel;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.walletAddr = config.walletAddress;
            this.blobConfig = config.blobConfig;
            this.pointRaw = config.pointRaw || 0
            this.pointConverted = config.pointConverted || 0

            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.isCancel = true
            this.open = false
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/module/Bitkub/style/base.scss";
@import "@/style/modal.scss";

.modal {
    @extend %modal;

    .modal-content {
        width: 100%;
    }
}
@import "style/ConfirmModal.scss";
</style>
